export default __webpack_public_path__ + "6b26adc8066c32c4cb9f31140cdb34a1.png";